import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_q_select, {
        clearable: "",
        filled: "",
        color: "accent",
        modelValue: _ctx.conditional.field,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.conditional.field) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.newField(), _ctx.conditionStackChange()))
        ],
        options: _ctx.fieldsAsArray,
        behavior: "menu",
        "option-label": _ctx.conditionLabel,
        label: _ctx.t('data.filtering.field')
      }, null, 8, ["modelValue", "options", "option-label", "label"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_q_select, {
        clearable: "",
        filled: "",
        color: "accent",
        modelValue: _ctx.conditional.operation,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.conditional.operation) = $event)),
          _cache[3] || (_cache[3] = ($event: any) => (_ctx.conditionStackChange()))
        ],
        options: _ctx.getOperators(_ctx.conditional),
        behavior: "menu",
        "option-label": _ctx.operatorLabel,
        label: _ctx.t('data.filtering.operator')
      }, null, 8, ["modelValue", "options", "option-label", "label"])
    ]),
    (_ctx.isDate(_ctx.conditional))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", null, [
            (_ctx.isDate(_ctx.conditional))
              ? (_openBlock(), _createBlock(_component_q_select, {
                  key: 0,
                  clearable: "",
                  filled: "",
                  color: "accent",
                  debounce: "400",
                  options: _ctx.getDateModifiers(),
                  behavior: "menu",
                  "option-label": _ctx.dateLabel,
                  label: _ctx.t('data.filtering.date'),
                  modelValue: _ctx.conditional.dateModifier,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.conditional.dateModifier) = $event)),
                    _cache[5] || (_cache[5] = ($event: any) => (_ctx.conditionStackChange()))
                  ]
                }, null, 8, ["options", "option-label", "label", "modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", null, [
            (
          _ctx.conditional.field === null ||
          (_ctx.isDate(_ctx.conditional) &&
            _ctx.conditional.dateModifier != null &&
            _ctx.conditional.dateModifier.input)
        )
              ? (_openBlock(), _createBlock(_component_q_input, {
                  key: 0,
                  color: "accent",
                  filled: "",
                  debounce: "400",
                  placeholder: _ctx.t('data.filtering.value'),
                  modelValue: _ctx.conditional.value,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((_ctx.conditional.value) = $event)),
                    _cache[7] || (_cache[7] = ($event: any) => (_ctx.conditionStackChange()))
                  ],
                  type: "date"
                }, null, 8, ["placeholder", "modelValue"]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.conditional.dateModifier != null && _ctx.conditional.dateModifier.input]
          ])
        ], 64))
      : (_ctx.isNumber(_ctx.conditional))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (
          _ctx.conditional.field === null || (!_ctx.isDropdown(_ctx.conditional) && !_ctx.isEmptyField(_ctx.conditional))
        )
              ? (_openBlock(), _createBlock(_component_q_input, {
                  key: 0,
                  color: "accent",
                  filled: "",
                  type: "number",
                  debounce: "400",
                  label: _ctx.t('data.filtering.value'),
                  modelValue: _ctx.conditional.value,
                  "onUpdate:modelValue": [
                    _cache[9] || (_cache[9] = ($event: any) => ((_ctx.conditional.value) = $event)),
                    _cache[12] || (_cache[12] = ($event: any) => (_ctx.conditionStackChange()))
                  ],
                  modelModifiers: { number: true },
                  onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.enterKey()), ["enter"])),
                  onKeypress: _cache[11] || (_cache[11] = ($event: any) => (_ctx.inputValidation($event, _ctx.conditional)))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "close",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => {;(_ctx.conditional.value = null), _ctx.conditionStackChange()}, ["stop"])),
                      class: "cursor-pointer"
                    })
                  ]),
                  _: 1
                }, 8, ["label", "modelValue"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (
          _ctx.conditional.field === null || (!_ctx.isDropdown(_ctx.conditional) && !_ctx.isEmptyField(_ctx.conditional))
        )
              ? (_openBlock(), _createBlock(_component_q_input, {
                  key: 0,
                  color: "accent",
                  filled: "",
                  debounce: "400",
                  label: _ctx.t('data.filtering.value'),
                  modelValue: _ctx.conditional.value,
                  "onUpdate:modelValue": [
                    _cache[14] || (_cache[14] = ($event: any) => ((_ctx.conditional.value) = $event)),
                    _cache[17] || (_cache[17] = ($event: any) => (_ctx.conditionStackChange()))
                  ],
                  onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.enterKey()), ["enter"])),
                  onKeypress: _cache[16] || (_cache[16] = ($event: any) => (_ctx.inputValidation($event, _ctx.conditional)))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "close",
                      onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => {;(_ctx.conditional.value = null), _ctx.conditionStackChange()}, ["stop"])),
                      class: "cursor-pointer"
                    })
                  ]),
                  _: 1
                }, 8, ["label", "modelValue"]))
              : (_ctx.isDropdown(_ctx.conditional) && !_ctx.isEmptyField(_ctx.conditional))
                ? _withDirectives((_openBlock(), _createBlock(_component_q_select, {
                    key: 1,
                    clearable: "",
                    filled: "",
                    multiple: "",
                    color: "accent",
                    modelValue: _ctx.conditional.value,
                    "onUpdate:modelValue": [
                      _cache[19] || (_cache[19] = ($event: any) => ((_ctx.conditional.value) = $event)),
                      _cache[20] || (_cache[20] = ($event: any) => (_ctx.conditionStackChange()))
                    ],
                    options: _ctx.options,
                    behavior: "menu",
                    label: _ctx.t('data.filtering.value')
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "close",
                        onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => {;(_ctx.conditional.value = null), _ctx.conditionStackChange()}, ["stop"])),
                        class: "cursor-pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "label"])), [
                    [_vShow, _ctx.isDropdown(_ctx.conditional) && !_ctx.isEmptyField(_ctx.conditional)]
                  ])
                : _createCommentVNode("", true)
          ]))
  ], 64))
}